export default "__VITE_ASSET__DLKa$wOX__"